import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import PaperTray from '../assets/FoodTray.png';
import PizzaBox from '../assets/PizzaBox.jpg';
import FoodBox from '../assets/FoodBox.png';
import PaperContainer from '../assets/PaperContainer.jpeg';
import BurgerBox from '../assets/BurgerBox.webp';
import PaperLid from '../assets/PaperLid.png';

const productData = [
    {
        name: 'Paper Container',
        image: PaperContainer,
        description: 'Durable food-grade containers ideal for curries, gravies, and rice items.',
        features: [
            'Durable and heat-tolerant',
            'Leak-proof lid compatibility',
            'Stackable design',
            'Eco-friendly material'
        ]
    },
    {
        name: 'Paper Lids',
        image: PaperLid,
        description: 'Secure fitting lids made from biodegradable paper, suitable for hot and cold items.',
        features: [
            'Tight seal',
            'Compatible with multiple containers',
            'Moisture resistant',
            'Recyclable material'
        ]
    },
    {
        name: 'Paper Tray',
        image: PaperTray,
        description: 'Sturdy and stylish trays for fries, snacks, and combos.',
        features: [
            'Grease-resistant',
            'Easy to hold design',
            'Ideal for fast food chains',
            'Custom sizes available'
        ]
    },
    {
        name: 'Pizza Box',
        image: PizzaBox,
        description: 'Rigid boxes made from kraft and duplex board for safe pizza delivery.',
        features: [
            'Ventilation holes for freshness',
            'Supports heavy pizza bases',
            'Custom branding support',
            'Eco-friendly printing options'
        ]
    },
    {
        name: 'Food Box',
        image: FoodBox,
        description: 'Multi-use food boxes ideal for biryani, noodles, or desserts.',
        features: [
            'Oil-resistant interior',
            'Secure flap closure',
            'Heat-tolerant paper design',
            'Biodegradable material'
        ]
    },
    {
        name: 'Burger Box',
        image: BurgerBox,
        description: 'Stylish burger boxes made from virgin kraft paper with smart locking design.',
        features: [
            'Secure locking tabs',
            'Available in multiple sizes/colors',
            'Highly durable for dine-in or delivery',
            'Supports custom prints'
        ]
    }
];


const DisposalContainer = () => {
    const [activeProduct, setActiveProduct] = useState(null);

    return (
        <>
            <Navbar />
            <section id="products" className="py-20 bg-gray-100">
                <div className="container mx-auto px-5">
                    <h2 className="text-center text-4xl mb-16 text-[#2c5530] font-bold relative after:content-[''] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-gradient-to-r after:from-[#ff6b6b] after:to-[#ffa500] after:rounded">
                        Disposal Container
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
                        {productData.map((product, index) => (
                            <div
                                key={index}
                                className="product-card bg-white rounded-2xl overflow-hidden shadow-xl hover:-translate-y-2 hover:shadow-2xl transition-all cursor-pointer"
                                onClick={() => setActiveProduct(product)}
                            >
                                <div className="h-48 flex items-center justify-center">
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="object-contain mt-4"
                                        style={{ width: '250px', height: '250px' }}
                                    />
                                </div>
                                <div className="p-6">
                                    <h3 className="text-xl text-[#2c5530] mb-2 font-semibold">{product.name}</h3>
                                    <p className="text-sm text-gray-600">{product.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {activeProduct && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={() => setActiveProduct(null)}
                >
                    <div
                        className="bg-white p-6 rounded-lg w-full max-w-md relative shadow-lg"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={() => setActiveProduct(null)}
                            className="absolute top-2 right-3 text-gray-600 text-2xl font-bold"
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                        <h3 className="text-2xl text-[#2c5530] font-semibold mb-4">{activeProduct.name}</h3>
                        <img
                            src={activeProduct.image}
                            alt={activeProduct.name}
                            className="w-full h-48 object-contain mb-4"
                        />
                        <p className="mb-2 text-gray-700">{activeProduct.description}</p>
                        <ul className="list-disc pl-5 text-sm text-gray-600">
                            {activeProduct.features.map((feature, index) => (
                                <li key={index}>{feature}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

        </>
    );
};

export default DisposalContainer;
